module.exports = __webpack_public_path__ + "img/icon-home-light.2368f849.svg";